import { combineReducers } from "redux";

import { reducer as login } from "ducks/login";
import { reducer as loginOld } from "ducks/login_old";
import { reducer as smsLogin } from "ducks/sms_login";
import { reducer as signup } from "ducks/signup";
import { reducer as nonbinary } from "ducks/nonbinary";
import { reducer as profileDetails } from "ducks/profile_details";
import { reducer as sms } from "ducks/sms";

const LoggedoutReducer = combineReducers({
	login,
	loginOld,
	smsLogin,
	signup,
	nonbinary,
	profileDetails,
	sms,
});

export default LoggedoutReducer;



// WEBPACK FOOTER //
// ./src/pages/loggedout/reducers/index.js